import React from 'react';

export const SpinnerSize = {
    DEFAULT: '',
    SMALL: ' spinner-sm',
};

export const SpinnerPosition = {
    LEFT: " ml-8",
    CENTER: " m-auto",
}

const Spinner = ({ size = SpinnerSize.DEFAULT, position = SpinnerPosition.CENTER }) => {
    return <div className={`spinner spinner-default-green d-block${size}${position}`}/>;
};

export default Spinner;
